'use client'

import classNames from 'classnames'
import { find, findIndex, isEqual, isFunction, map } from 'lodash-es'
import FilterNormalContext from './context'
import { useFilterNormalContext } from './context'
import { useCallback, useEffect, useMemo } from 'react'
import { areaLableToNumber, getSlug, slugToId, toNumber } from '@utils'
import { useList } from 'react-use'
import { HOUSE_FILTER_ALIAS } from '@config'

export default function FilterItemNormal({
  data,
  value: defaultValue,
  state,
  onChange,
  twoCols = false,
  isSlug = false
}) {

  const [value, { set: setValue, push: pushValue, removeAt: removeValue }] = useList(defaultValue)
  useEffect(() => {
    isFunction(onChange) && onChange(value)
  }, [value, onChange])

  useEffect(() => {
    setValue(d => {
      if (isEqual(d, defaultValue)) {
        return d
      } else {
        return defaultValue
      }
    })
  }, [setValue, defaultValue])
  return (
    <FilterNormalContext.Provider value={{ state, value, twoCols, isSlug, setValue, pushValue, removeValue }}>
      <div className={classNames('gap-14 max-h-300 overflow-auto sm:max-h-none', twoCols ? 'grid grid-cols-2' : 'flex')}>
        {
          map(data.children, item => (
            <Item data={item} key={item.label}></Item>
          ))
        }
      </div>
    </FilterNormalContext.Provider>
  )
}

function Item({
  data
}) {

  const { value, twoCols, isSlug, setValue, pushValue, removeValue } = useFilterNormalContext()

  const itemValue = useMemo(() => {
    if (HOUSE_FILTER_ALIAS.landarea.includes(data.alias) || HOUSE_FILTER_ALIAS.floorarea.includes(data.alias)) {
      return areaLableToNumber(data.label)
    } else {
      return isSlug ? getSlug(data.label, data.value) : toNumber(data.value)
    }
  }, [data, isSlug])

  // 当前块是否选中
  const selected = useMemo(() => {
    return !!find(value, item => toNumber(slugToId(item)) === toNumber(slugToId(itemValue)))
  }, [value, itemValue])

  // 切换选中事件
  const toggleHandle = useCallback(() => {
    // 数据位0的不让选择，除非它已经被选中过，可以取消
    if (!data.num && !selected) return
    // 可多选逻辑
    if (data.isMultiple) {
      const idx = findIndex(value, item => item === itemValue)
      if (idx === -1) {
        pushValue(itemValue)
      } else {
        removeValue(idx)
      }
    } else {
      // 单选逻辑
      setValue(selected ? [] : [itemValue])
    }
  }, [data, selected, itemValue, value, setValue, pushValue, removeValue])
  return (
    <div className='flex-1'>
      <div
        className={classNames(
          'border rounded-md h-50 flex items-center justify-center text-font',
          data.num === 0 && !selected ? 'cursor-not-allowed' : 'cursor-pointer',
          { 'bg-primary-light border-primary text-primary': selected },
          { '!justify-between px-10': twoCols }
        )}
        onClick={toggleHandle}
      >
        {
          twoCols
            ? (
              <>
                <span className='text-sm whitespace-nowrap overflow-hidden flex-1 text-ellipsis'>{data.label}</span>
                <span className={classNames('text-sm', selected ? 'text-primary' : 'text-neutral-3')}>({data.num})</span>
              </>
            )
            : data.label
        }
      </div>
      {
        !twoCols && <div className='mt-6 text-center text-xs text-neutral-3'>{data.num}</div>
      }
    </div>
  )
}